import React from 'react';
import { motion } from 'framer-motion';
export function Shift() {
  return <section className="py-32 md:py-48 bg-primary relative flex items-center justify-center text-center overflow-hidden" data-id="element-142">
      {/* Subtle background element */}
      <div className="absolute inset-0 flex items-center justify-center opacity-[0.05] pointer-events-none" data-id="element-143">
        <div className="w-[800px] h-[800px] rounded-full border border-tertiary" data-id="element-144" />
        <div className="absolute w-[600px] h-[600px] rounded-full border border-tertiary" data-id="element-145" />
        <div className="absolute w-[400px] h-[400px] rounded-full border border-tertiary" data-id="element-146" />
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-148">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif text-text-light leading-tight mb-8" data-id="element-149">
            The best strategy talent in the world is no longer locked inside
            consulting firms.
          </h2>
          <p className="text-2xl md:text-4xl font-serif text-text-muted italic mb-8" data-id="element-150">
            It's in the world's top business schools.
          </p>
          <p className="text-xl md:text-2xl text-accent tracking-widest uppercase font-medium" data-id="element-151">
            And now, it's accessible.
          </p>
        </motion.div>
      </div>
    </section>;
}